export const STORAGE_PREFIX = "vast_entity."

export type StorageItem = {
  key: string
  value: string
}
